<template>
  <el-form :model="feedbackForm" label-width="100px" ref="feedbackForm"  :loading="loading">
    <el-form-item label="问题类型" prop="name" required>
      <el-form-item >
        <el-select v-model="feedbackForm.type" placeholder="请选择问题类型">
          <el-option
            v-for="item in types"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form-item>
    <el-form-item label="联系电话" prop="phone">
      <el-input v-model="feedbackForm.phone" placeholder="请输入联系电话"/>
    </el-form-item>
    <el-form-item label="联系邮箱" prop="email">
      <el-input v-model="feedbackForm.email" placeholder="请输入联系邮箱"/>
    </el-form-item>
    <el-form-item label="详细描述" prop="content" required>
      <el-input type="textarea" v-model="feedbackForm.content" placeholder="请详细描述您的问题" multiline/>
    </el-form-item>
    <el-form-item size="large">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {feedback} from './homeApi'

export default {
  name: 'feedback',
  data () {
    return {
      loading: false,
      types: [
        {
          id: 1,
          text: '问题反馈'
        },
        {
          id: 2,
          text: '需求咨询'
        }
      ],
      feedbackForm: {
        type: null,
        phone: '',
        email: '',
        content: ''
      }
    }
  },
  methods: {
    submit () {
      feedback(this.feedbackForm).then(rsp => {
        const { code, message } = rsp
        if (code === 0) {
          this.$message.success('反馈成功,后续可能有专人联系您')
          this.$emit('dismiss')
        } else {
          this.$message.error(message)
        }
      })
    },
    cancel () {
      this.$emit('dismiss')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/feedback.vue